//@flow

import React, { Component } from 'react'
import store from '../../../../../admin/store'
import classnames from 'classnames'
import toggleCheerFunc, { switchUserCheerStatus } from '../../../shared/toggle-cheer'
import { connect } from 'react-redux'
import Button from '../../../shared/sn-button'
import SnIcon from '../../../shared/sn-icon'
import Loader from '../../../shared/loader'
import { i18n } from '../../../../../validator'
import {
    SET_CHEER_ENTITY,
    SET_USER_IS_CHEER,
} from '../../../../../admin/reducers/app'

type Props = {
    +event?: {
        cheers_count: number,
        additionalInfo: {
            data: {
                userStatus: any,
            },
        },
    },
    +authedUser: Object,
    +entity: Object,
    +userIsCheer: boolean,
    +cheerBusy: boolean,
    +fromList: boolean,
    +showButtonText: boolean,

    // props inherited via decorators
    +t: Function,
}

type State = {
    activeIcon: boolean,
}

@i18n()
export class Subscribe extends Component<Props, State> {

    constructor(props) {
        super(props)

        store.dispatch({
            type: SET_USER_IS_CHEER,
            userIsCheer: this.userIsCheer(),
        })

        this.state = {
            activeIcon: props?.event?.additionalInfo?.data?.userStatus?.isCheering || false,
        }
    }

    /**
     * Triggers unauthed user model
     * @returns {Promise<void>}
     */
    triggerUnauthedUserModal = () => {
        store.dispatch({
            type: 'SET_LOGIN_MODAL',
            text: i18n.t('fanGroup.unloggedUser.text'),
        })

        return new Promise(resolve => resolve())
    }

    /**
     * Toggle cheer
     */
    toggleCheer = () => {
        const {
            event,
            authedUser,
            fromList,
        } = this.props

        store.dispatch({
            type: SET_CHEER_ENTITY,
            entity: event,
        })

        if (authedUser) {
            this.setState({ activeIcon: !this.state.activeIcon })
        }

        toggleCheerFunc(false, false).then(response => {
            if (response && response.data) {
                store.dispatch({
                    type: SET_CHEER_ENTITY,
                    entity: {
                        ...this.props.entity,
                        cheers_count: response.data.total_entity_cheers_count,
                    },
                })
            }

            if (fromList) {
                store.dispatch({
                    type: 'SET_USER_IS_CHEER',
                    userIsCheer: false,
                })
            }
        })
    }

    /**
     * "Uncheer" current user from given entity
     *
     * @return {Promise<void>}
     */
    deleteCheerFunc = () => {
        const {
            cheerBusy,
            authedUser,
            event,
        } = this.props

        if (!authedUser) {
            return this.triggerUnauthedUserModal()
        }

        if (!cheerBusy) {
            store.dispatch({
                type: 'TOGGLE_BUSY_CHEER',
            })
        }

        this.setState({ activeIcon: !this.state.activeIcon })

        let payload = {
            id: event?.id,
            type: 'events',
        }

        switchUserCheerStatus(
            'delete',
            { params: payload },
            false,
            event
        )
    }

    /**
     * Check if user is cheering
     */
    userIsCheer = (): boolean => {
        const {
            authedUser,
            event: {
                additionalInfo,
            },
        } = this.props

        const userStatus = additionalInfo && additionalInfo.data.userStatus

        return authedUser && userStatus ? userStatus.isCheering : false
    }

    /**
     * Render button for event list
     *
     * @return {React.Node}
     */
    renderEventListButton = () => {
        const { activeIcon } = this.state

        const { cheerBusy } = this.props

        return(
            <Button
                className={classnames({
                    'u-circle p-0 m-0': true,
                    'u-circle--active': activeIcon,
                })}
                onClick={!activeIcon ? this.toggleCheer : this.deleteCheerFunc}
            >
                <div className="u-circle__icon d-flex align-items-center justify-content-center mb-0 pt-0">
                    {!cheerBusy && activeIcon &&
                        <SnIcon className="sn-cheer-circle-fill sn-md text-color-brand" />
                    }
                    {!cheerBusy && !activeIcon &&
                        <SnIcon
                            isHoverable={true}
                            className="sn-md text-color-brand"
                            notHoverClassName="sn-cheer-circle-empty"
                            hoverClassName="sn-cheer-circle-fill"
                        />
                    }
                    {cheerBusy && <Loader className="u-circle__loader"/>}
                </div>
            </Button>
        )
    }

    render() {
        const {
            userIsCheer,
            cheerBusy,
            t,
            showButtonText,
            fromList,
        } = this.props

        if (fromList) {
            return this.renderEventListButton()
        }

        const userIsCheering = userIsCheer

        return(
            <Button
                className={classnames({
                    'u-circle': true,
                    'u-circle--active': userIsCheering,
                })}
                onClick={this.toggleCheer}
            >
                <div className="u-circle__icon">
                    {!cheerBusy && userIsCheering &&
                        <SnIcon className="sn-cheer-circle-fill sn-lg text-color-brand"/>
                    }
                    {!cheerBusy && !userIsCheering &&
                        <SnIcon
                            isHoverable={true}
                            className="sn-lg text-color-brand"
                            notHoverClassName="sn-cheer-circle-empty"
                            hoverClassName="sn-cheer-circle-fill"
                        />
                    }
                    <div className="u-circle__icon">
                        {cheerBusy && <Loader className="u-circle__loader" />}
                    </div>
                </div>
                {showButtonText ? (!cheerBusy && userIsCheering ? t('iCheer') : t('cheer')) : null}
            </Button>
        )
    }
}

export default connect((state, ownProps) => ({
    userIsCheer: state.app.cheer.isCheer,
    cheerBusy: state.app.cheer.busy,
    authedUser: state.auth.user,
    entity: state.app.cheer.entity,
}))(Subscribe)
